import { State } from 'interfaces/state'
import { AccountsDetailsOwnProps, AccountsDetailsStateProps } from 'components/features/pfm/AccountsDetailsModule/AccountsDetailsModule'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { memberAllAccountsGuard } from 'guards/accountGuards'
import { ALL_CATEGORY_ID } from 'constants/meta'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import AccountsDetailsModule from 'components/features/pfm/AccountsDetailsModule/AccountsDetailsModule'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { DetailedAccount } from 'interfaces/accounts'

const mapStateToProps = (state: State, { type }: AccountsDetailsOwnProps): AccountsDetailsStateProps => {
  const { app, data } = state
  const accounts = data[type].accounts
  if (!accounts) {
    throw createForgottenGuardError('AccountsDetailsModuleContainer', 'memberAccountDetailsGuard')
  }

  let rows = [...getItemsFromCollection<DetailedAccount, 'id'>(accounts.provided), ...getItemsFromCollection<DetailedAccount, 'id'>(accounts.manual)]
  const { selectedId: selectedCategoryId } = app[type].categories
  if (selectedCategoryId !== ALL_CATEGORY_ID) {
    rows = rows.filter((row) => row.category.id === selectedCategoryId)
  }

  const isMobile = isMobileSelector(state)

  return {
    rows,
    isMobile,
  }
}

const accountsDetailsGuards: Guards<AccountsDetailsOwnProps> = [
  memberAllAccountsGuard,
]

export default connectShadedLoadable<
  AccountsDetailsStateProps,
  {},
  AccountsDetailsOwnProps
>(mapStateToProps, undefined, accountsDetailsGuards)(AccountsDetailsModule)
